import { Injectable } from '@angular/core';
import { Workbook } from 'exceljs'
import * as FileSaver from 'file-saver'
const EXCEL_TYPE =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
const EXCEL_EXTENSION = '.xlsx'

@Injectable({
  providedIn: 'root'
})
export class ExcelService {

  constructor() { }
   public exportAsExcelFile(
    data: any[],
    excelFileName: string,
    headersArray: any[]
  ): void {
    const workbook = new Workbook()
    const worksheet = workbook.addWorksheet(excelFileName)
    const headerRow = worksheet.addRow(
      headersArray.map((header) => header.label)
    )

    // set up header design
    headerRow.eachCell((cell) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '1890FF' },
      }
      cell.font = { color: { argb: 'FFFFFF' }, name: 'Roboto' }
      cell.border = {
        top: { style: 'thin', color: { argb: 'FFFFFF' } },
        left: { style: 'thin', color: { argb: 'FFFFFF' } },
        bottom: { style: 'thin', color: { argb: 'FFFFFF' } },
        right: { style: 'thin', color: { argb: 'FFFFFF' } },
      }
    })
    worksheet.properties.defaultRowHeight = 20 // define all row default height
    worksheet.getRow(1).height = 25 // define header height

    // push each row as header data
    data.forEach((element, i) => {
      let eachRow:Array<any> = [];
      headersArray.forEach((header) => {
        eachRow.push(element[header.label])
      })
      worksheet.addRow(eachRow)
    })

    // define width and alignment
    headersArray.forEach((header, index: number) => {
      worksheet.getColumn(index + 1).width = headersArray[index].width
      if (headersArray[index].class === 'align-left')
        worksheet.getColumn(index + 1).alignment = {
          wrapText: true,
          vertical: 'middle',
        }
      else
        worksheet.getColumn(index + 1).alignment = {
          wrapText: true,
          vertical: 'middle',
          horizontal: 'center',
        }
    })

    workbook.xlsx.writeBuffer().then((result) => {
      const blob = new Blob([result], { type: EXCEL_TYPE })
      FileSaver.saveAs(
        blob,
        excelFileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION
      )
    })
  }
}
